import { makeResetStyles, makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingCommandBarTabSlots, GroundingCommandBarTabState } from './GroundingCommandBarTab.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingCommandBarTabClassNames: SlotClassNames<GroundingCommandBarTabSlots> = {
  root: 'fai-GroundingCommandBarTab',
  tab: 'fai-GroundingCommandBarTab__tab',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  tab: {
    // To account for the outline when key focused
    margin: tokens.strokeWidthThick,
    paddingTop: tokens.spacingVerticalSNudge,
    paddingBottom: tokens.spacingVerticalSNudge,
  },
});

const useRootBaseClassName = makeResetStyles({
  minWidth: 'max-content',
  paddingRight: tokens.spacingHorizontalSNudge,
});

/**
 * Apply styling to the GroundingCommandBarTab slots based on the state
 */
export const useGroundingCommandBarTabStyles_unstable = (
  state: GroundingCommandBarTabState,
): GroundingCommandBarTabState => {
  'use no memo';

  const rootBaseClassName = useRootBaseClassName();
  const styles = useStyles();

  state.root.className = mergeClasses(groundingCommandBarTabClassNames.root, rootBaseClassName, state.root.className);

  if (state.tab) {
    state.tab.className = mergeClasses(groundingCommandBarTabClassNames.tab, styles.tab, state.tab.className);
  }

  return state;
};
